import classNames from "classnames";
import { PhosphorArrowUDownLeftButton } from "components/Atoms/PhosphorIconButton";
import equal from "fast-deep-equal";
import React from "react";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";
import { MergeSectionField } from "./types";

interface Props<T> {
  field: MergeSectionField<T>
}

export const MergeFieldWithLabel = <T extends any>({ field }: Props<T>) => {
  const hasSublabel = field.sublabel != null;
  const isCurrentValueEqualToSourceValue = equal(field.currentValue, field.sourceValue);
  const isCurrentValueEqualToExistingValue = equal(field.currentValue, field.existingValue);

  const title = `${field.label}${hasSublabel ? `\n${field.sublabel}` : ""}`;

  return <>
    <div title={title} className={classNames("main-section-template-fields-label", {
      "flex gap": field.supportArticleId,
    })}>
      {field.label}
      {field.supportArticleId && <SupportQuestionMark small articleId={field.supportArticleId} />}
      {hasSublabel && <div className="s1_small">{field.sublabel}</div>}
    </div>
    <div
      onClick={!isCurrentValueEqualToSourceValue ? field.onSourceClick : undefined}
      className={classNames("merge-section-template-field", {
        "merge-section-template-field-diff": !isCurrentValueEqualToSourceValue,
        "main-section-template-fields-empty": field.isEmpty(field.sourceValue),
      })}>
      {field.isEmpty(field.sourceValue) ? <span>{RESX.Advancing.NoValue}</span> : field.render(field.sourceValue)}
    </div>
    <div className="merge-section-template-field-revert-button">
      {!isCurrentValueEqualToExistingValue && <PhosphorArrowUDownLeftButton onClick={field.onExistingClick} layout="in-square" />}
    </div>
    <div className={classNames("merge-section-template-field merge-section-template-field-existing", {
      "main-section-template-fields-empty": field.isEmpty(field.currentValue),
    })}>
      {field.isEmpty(field.currentValue) ? <span>{RESX.Advancing.NoValue}</span> : field.render(field.currentValue)}
    </div>
  </>
};